export default function JobApplicationsTable({
  records,
  setSelectedSignup,
}) {
  return (
    <table className="w-full text-left">
      <thead className="bg-sage-50">
        <tr>
          <th className="px-6 py-4">Name</th>
          <th className="px-6 py-4">Role</th>
          <th className="px-6 py-4">Experience</th>
          <th className="px-6 py-4">Phone</th>
          <th className="px-6 py-4">Status</th>
          <th className="px-6 py-4">Resume</th>
          <th className="px-6 py-4">Action</th>
        </tr>
      </thead>

      <tbody>
        {records.map((candidate) => (
          <tr
            key={candidate.id}
            className="border-t border-sage-100"
          >
            <td className="px-6 py-4">
              {candidate.full_name || "-"}
            </td>

            <td className="px-6 py-4">
              {candidate.role || "-"}
            </td>

            <td className="px-6 py-4">
              {candidate.experience_years || "-"}
            </td>

            <td className="px-6 py-4">
              {candidate.phone || "-"}
            </td>

            <td className="px-6 py-4">
              <span className="px-3 py-1 rounded-full bg-sage-100 text-sage-700 text-sm">
                {candidate.status || "New"}
              </span>
            </td>

            <td className="px-6 py-4">
              {candidate.resumeUrl ? (
                <a
                  href={candidate.resumeUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sage-700 hover:underline"
                >
                  View Resume
                </a>
              ) : (
                "-"
              )}
            </td>

            <td className="px-6 py-4">
              <button
                onClick={() => setSelectedSignup(candidate)}
                className="text-sage-700 hover:underline"
              >
                View
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}